import { render, staticRenderFns } from "./directory.vue?vue&type=template&id=52db7cdc&scoped=true&"
import script from "./directory.vue?vue&type=script&lang=js&"
export * from "./directory.vue?vue&type=script&lang=js&"
import style0 from "./directory.vue?vue&type=style&index=0&id=52db7cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db7cdc",
  null
  
)

export default component.exports